import { Form } from "react-bootstrap";

const FormField = ({ label, children, controlId, error }) => {
  return (
    <Form.Group className="mb-4" controlId={controlId}>
      {label && <Form.Label>{label}</Form.Label>}
      {children}
      {!!error && (
        <Form.Text className="text-danger">{error.message}</Form.Text>
      )}
    </Form.Group>
  );
};

export default FormField;
